// hooks/useFormatters.js
import { useMemo } from 'react';

/**
 * Hook customizado para formatação de dados
 */
export const useFormatters = () => {
    const formatCNPJ = (cnpj) => {
        if (!cnpj) return "-";
        const cleaned = cnpj.replace(/\D/g, "");
        if (cleaned.length !== 14) return cnpj;
        return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    };

    const formatPhone = (phone) => {
        if (!phone) return "-";
        const cleaned = phone.replace(/\D/g, "");
        if (cleaned.length === 11) {
            return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
        }
        if (cleaned.length === 10) {
            return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
        }
        return phone;
    };

    const formatCPF = (cpf) => {
        if (!cpf) return "-";
        const cleaned = cpf.replace(/\D/g, "");
        if (cleaned.length !== 11) return cpf;
        return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    };

    const formatCEP = (cep) => {
        if (!cep) return "-";
        const cleaned = cep.replace(/\D/g, "");
        if (cleaned.length !== 8) return cep;
        return cleaned.replace(/(\d{5})(\d{3})/, "$1-$2");
    };

    const formatCurrency = (value) => {
        if (!value && value !== 0) return "-";
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR') + ' ' + date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    };

    // Versão memoizada para valores que mudam frequentemente
    const memoizedFormatter = useMemo(() => ({
        formatCNPJ: (cnpj) => formatCNPJ(cnpj),
        formatPhone: (phone) => formatPhone(phone),
        formatCPF: (cpf) => formatCPF(cpf),
        formatCEP: (cep) => formatCEP(cep),
        formatCurrency: (value) => formatCurrency(value),
        formatDate: (dateString) => formatDate(dateString),
        formatDateTime: (dateString) => formatDateTime(dateString),
    }), []);

    return memoizedFormatter;
};

export default useFormatters;